import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsShellWrapper from '../SettingsShellWrapper.vue';
import AttributesHome from './Index.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
  permissions: ['administrator'],
};

/**
 * Custom attributes are one page served under two routes, one per model: both
 * sit in the settings Data group, as `Conversation attributes` and `People
 * attributes`. The model is a route prop, so each nav leaf lands on its own
 * list instead of on a tab the reader has to find first.
 */
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      component: SettingsShellWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'attributes_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'attributes_list',
          component: AttributesHome,
          props: { attributeModel: 'conversation_attribute' },
          meta,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/customer-fields'),
      component: SettingsShellWrapper,
      children: [
        {
          path: '',
          name: 'customer_attributes_list',
          component: AttributesHome,
          props: { attributeModel: 'contact_attribute' },
          meta,
        },
      ],
    },
  ],
};
